import { useEffect, useState } from 'react';
import SectionEvent from '../../elements/SectionEvent';
import banner from '../../../assets/banner/bg-berita-artikel.png';
import { MagnifyingGlassIcon, ChevronLeftIcon, ChevronRightIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { getPaginationSummary, hasNextPage } from '../../../utils/pagination.utils';
import Card from '../../elements/ArticleCard';
import { Button, Spinner } from '@nextui-org/react';
import GalleryCard from '../../elements/GaleryCard';

export default function LayoutInformasi({
    title,
    infoData,
    contentType,
    selectedContentType,
    setContentType,
    keyword,
    setSearch,
    searchLabel,
    handleNextPage,
    handlePrevPage,
    isLoading,
}) {
    const [currentKeyword, setCurrentKeyword] = useState(keyword);

    useEffect(() => {
        const handler = setTimeout(() => {
            setSearch(currentKeyword);
        }, 400);

        return () => clearTimeout(handler);
    }, [currentKeyword, setSearch]);

    function KategoriFilter({ categories }) {
        return (
            <div className="flex flex-col space-y-2">
                <Button
                    className={`flex items-center justify-between p-2 rounded-md ${!selectedContentType && 'bg-selected'}`}
                    onClick={() => setContentType(null)}
                >
                    <div className="flex flex-row gap-2 justify-center items-center">
                        {!selectedContentType && (
                            <span>
                                <CheckCircleIcon className="size-4" />
                            </span>
                        )}
                        <span>Semua Jenis</span>
                    </div>

                    <span className="text-ink-500"></span>
                </Button>
                {categories?.map((category, index) => (
                    <Button
                        key={index}
                        className={`flex items-center justify-between bg-surface-3 p-2 rounded-md ${category === selectedContentType && 'bg-selected'}`}
                        onClick={() => setContentType(category)}
                    >
                        <div className="flex flex-row gap-2 justify-center items-center">
                            {category === selectedContentType && (
                                <span>
                                    <CheckCircleIcon className="size-4" />
                                </span>
                            )}
                            <span>{category}</span>
                        </div>
                    </Button>
                ))}
            </div>
        );
    }

    return (
        <div className="relative">
            <img alt="bg-login" src={banner} className="w-full h-[45vh] object-fill" />
            <div className="absolute top-[3%] flex flex-col justify-center text-white px-36 space-y-4">
                <p className="text-4xl md:text-7xl font-semibold">{title}</p>
            </div>
            <div className="px-32 py-16 relative">
                {/* Overlay spinner */}
                {isLoading && (
                    <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50">
                        <Spinner size="lg" color="primary" /> {/* Spinner dari NextUI */}
                    </div>
                )}
                <div className="flex flex-row mb-4">
                    <div className="w-[20%] mr-10">
                        <h1 className="text-xl mb-4">Jenis Informasi</h1>
                        <KategoriFilter categories={contentType} />
                    </div>
                    <div className="w-full text-[#51625E]">
                        <h1 className="text-xl mb-4">{searchLabel}</h1>
                        <div className="flex flex-row justify-between">
                            <div className="relative w-full">
                                <input
                                    type="text"
                                    placeholder="Cari berdasarkan judul informasi"
                                    value={currentKeyword}
                                    onChange={(e) => setCurrentKeyword(e.target.value)}
                                    className="w-full p-2 pl-4 pr-10 border border-[#51625E] rounded-xl"
                                />
                                <div className="absolute top-1/2 right-3 transform -translate-y-1/2 text-[#51625E]">
                                    <MagnifyingGlassIcon className="w-6 h-6" />
                                </div>
                            </div>
                        </div>
                        {infoData?.data?.length > 0 ? (
                            <div className="mt-8 grid grid-cols-2 gap-4">
                                {infoData?.data?.map((data, index) => (
                                    <div className="bg-surface-3">
                                        {selectedContentType === 'Galeri' ? (
                                            <GalleryCard data={data} key={index} />
                                        ) : (
                                            <Card data={data} key={index} />
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center p-16">Informasi tidak ditemukan</div>
                        )}

                        {selectedContentType && infoData?.data?.length > 0 && (
                            <div className="flex flex-row justify-end">
                                <p className="mr-4">Menampilkan:</p>
                                <p className="mr-4">
                                    {getPaginationSummary({
                                        total: infoData?.total || 0,
                                        limit: infoData?.limit || 0,
                                        currentPage: infoData?.page || 1,
                                    })}
                                </p>
                                <ChevronLeftIcon
                                    className={`size-6 ${infoData?.page > 1 && 'cursor-pointer'}`}
                                    onClick={() => handlePrevPage()}
                                />
                                <ChevronRightIcon
                                    className={`size-6 ${
                                        hasNextPage({
                                            total: infoData?.total,
                                            limit: infoData?.limit,
                                            currentPage: infoData?.page,
                                        }) && 'cursor-pointer'
                                    }`}
                                    onClick={() => handleNextPage()}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <SectionEvent />
        </div>
    );
}
